<template>
  <div>
    <div
      v-for="(terms, index) in termsList"
      :key="index"
    >
      <h6
        v-if="terms.title"
        class="d-flex justify-content-center"
      >
        <span v-html="terms.title" />
      </h6>
      <article
        class="mb-4"
        v-html="terms.desc"
      />
    </div>

    <div class="text-center">
      <b-button
        v-if="termsType !== 'beforestart' && termsType !== 'afterend'"
        class="w-100 mx-auto d-block d-lg-inline-block"
        :style="{
          background: 'rgba(' + MgmData.themeColor + ', 1.0)',
          'border-color': 'rgba(' + MgmData.themeColor + ', 1.0)',
        }"
        @click="set({ name: 'showTerms', value: false })"
      >
        {{ $t("global.confirm") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['MgmData', 'termsType']),
    ...mapState('sso', ['wording']),
    termsList() {
      const list = [];

      switch (this.termsType) {
        case 'activity-rules':
          list.push({
            title: this.$t('activity.activity-rules'),
            desc: this.MgmData.introductionInfo,
          });

          break;

        case 'binding-clause': {
          const wordings = this.wording.filter(
            (d) => ['BindingPolicy'].indexOf(d.paramCode) > -1,
          );

          const haveTitle = wordings.find((d) => d.paramOrder === 1);
          const haveDesc = wordings.find((d) => d.paramOrder === 2);

          list.push({
            title: haveTitle ? haveTitle.paramValue : '',
            desc: haveDesc ? haveDesc.paramValue : '',
          });

          break;
        }

        case 'membership-terms':
          this.wording
            .filter(
              (d) => ['PrivacyPolicy', 'UserTerms'].indexOf(d.paramCode) > -1,
            )
            .sort((a, b) => a.paramOrder - b.paramOrder)
            .forEach((element) => {
              list.push({
                desc: element.paramValue,
              });
            });

          break;

        case 'beforestart':
          list.push({
            title: this.$t('activity.beforestart'),
            desc: this.MgmData.beforeWording,
          });
          break;

        case 'afterend':
          list.push({
            title: this.$t('activity.afterend'),
            desc: this.MgmData.afterWording,
          });
          break;

        default:
          break;
      }
      return list;
    },
  },
  methods: {
    ...mapMutations(['set']),
  },
};
</script>
